var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoaded)?_c('div',{staticStyle:{"height":"100%"}},[_c('zone-container-thermostat',{attrs:{"id":"thermostat","zone":_vm.zone,"installationId":_vm.installation['.key']}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }